import React from 'react';
import PropTypes from 'prop-types';


function AffiliateDetail(props) {
  const { image, title, desc, logo } = props;

  return (
    <div className="affiliate-detail flex flex-col items-center justify-evenly">
      <img alt="detail" src={image || logo} />
      <h3 className="bolder">
        {title}
      </h3>
      <h4 className="text-center gray">
        {desc}
      </h4>
    </div>
  );
}

export default AffiliateDetail;

AffiliateDetail.propTypes = {
  desc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  logo: PropTypes.string,
};

AffiliateDetail.defaultProps = {
  image: '',
  logo: '',
};
